<template>
  <div
    class="logo section"
    :style="sectionStyle"
  >
    <div class="container">
      <img
        v-if="photoUrl"
        :src="photoUrl"
        alt="logoUrl"
      >
    </div>
  </div>
</template>

<script>
import backgroundMixin from './mixins/backgroundMixin';

export default {
  name: 'LogoSection',
  mixins: [backgroundMixin],
  props: {
    photoUrl: {
      type: String,
      default: undefined,
    },
    backgroundImage: {
      type: String,
      default: undefined,
    },
    backgroundColor: {
      type: String,
      default: undefined,
    },
  },
};
</script>
